import React, { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';
import './App.css';

import Footer from './components/Footer';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MobileBottomBar from './components/MobileBottomBar';

import About from './components/About';
import TestimonialCarousel from './components/Testimonial';
import ContactUs from './components/ContactUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import Services from './components/Services';
import ThankYou from './components/Thankyou';
import WhyChooseUs from './components/WhyChooseUs';
import DentalComparisonSection from './components/DentalComparisonSection';
import RootCanalTreatment from './components/Rct';
import WisdomToothExtraction from './components/WisdomToothExtraction';
import BracesAndAligners from './components/BracesAndAligners';
import SmileMakeover from './components/SmileMakeover';
import RoutineCheckupsAndCleaning from './components/RoutineCheckupAndCleaning';
import PediatricDentistry from './components/PediatricDentistry';
import GumDiseaseTreatment from './components/GumDiseaseTreatment';
import DentalImplants from './components/Implants';
import TeethWhitening from './components/Whitening';
import DentalLinks from './components/DentalLinks';

// GTM Container Reloader Component
function GTMContainerReloader() {
    const location = useLocation();

    useEffect(() => {
        // Reload GTM container on route change
        if (window.google_tag_manager) {
            Object.keys(window.google_tag_manager)
                .filter((k) => k.startsWith('GTM-'))
                .forEach((containerId) => {
                    try {
                        window.google_tag_manager[containerId].load();
                    } catch (error) {
                        console.error('GTM Container Reload Error:', error);
                    }
                });
        }
    }, [location.pathname]);

    return null;
}

function HomePage() {
    return (
        <>
            <HeroSection />
            <Services />
            <WhyChooseUs />
            <TestimonialCarousel />
            <About />
            {/* <BlogSection /> */}
        </>
    );
}

function App() {
    return (
        <Router>
            <GTMContainerReloader />
            <Routes>
                {/* Special standalone route for DentalLinks without Header/Footer */}
                <Route path='/quick-links' element={<DentalLinks />} />

                {/* All other routes with Header/Footer */}
                <Route path='*' element={
                    <div className='App'>
                        <Header />
                        <Routes>
                            <Route path='/' element={<HomePage />} />
                            <Route path='/contact' element={<ContactUs />} />
                            <Route path='/thank-you' element={<ThankYou />} />
                            <Route path='/privacy' element={<PrivacyPolicy />} />
                            <Route path='/rct' element={<RootCanalTreatment />} />
                            <Route path='/wisdom-tooth-extraction' element={<WisdomToothExtraction />} />
                            <Route path='/braces-aligners' element={<BracesAndAligners />} />
                            <Route path='/smile-makeover' element={<SmileMakeover />} />
                            <Route path='/checkups-cleaning' element={<RoutineCheckupsAndCleaning />} />
                            <Route path='/pediatric-dentistry' element={<PediatricDentistry />} />
                            <Route path='/gum-disease-treatment' element={<GumDiseaseTreatment />} />
                            <Route path='/dental-implants' element={<DentalImplants />} />
                            <Route path='/teeth-whitening' element={<TeethWhitening />} />
                        </Routes>
                        <MobileBottomBar />
                        <Footer />
                    </div>
                } />
            </Routes>
        </Router >
    );
}

export default App;
